import groupBy from 'lodash/groupBy';
import { Spin } from 'platform-components';
import React, { useMemo } from 'react';

import { CourseContainerParagraph } from '../__paragraph/course-container__paragraph';
import { useModulesQuery } from '../queries';

import './course-container__paragraphs.scss';

interface Props {
    modulesQuery: ReturnType<typeof useModulesQuery>;
    titlesOnly?: boolean;
}

export const CourseContainerParagraphs = ({ modulesQuery, titlesOnly }: Props) => {
    const cmodules = modulesQuery.data?.cmodules;
    const groups = useMemo(() => Object.entries(groupBy(cmodules || [], 'group_name')), [cmodules]);

    const renderModules = () =>
        groups.map(([groupName, modules], index) => (
            <CourseContainerParagraph
                groupName={groupName}
                key={groupName}
                modules={modules}
                order={index + 1}
                titlesOnly={titlesOnly}
            />
        ));

    return <div className="course-container__paragraphs">{modulesQuery.isSuccess ? renderModules() : <Spin />}</div>;
};
